import { render, staticRenderFns } from "./programa-select.vue?vue&type=template&id=13be3d3c&"
import script from "./programa-select.component.ts?vue&type=script&lang=ts&"
export * from "./programa-select.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports